<template>
  <TableLayout :permissions="['business:orders:query']">
    <!-- 搜索表单 -->
    <el-form ref="searchForm" slot="search-form" :model="searchForm" label-width="100px" inline>
      <el-form-item label="订单号" prop="releaseMemberId">
        <el-input v-model="searchForm.code" style="width: 120px"  clearable placeholder="请输入订单号" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="接单方" prop="acceptName">
        <el-input v-model="searchForm.acceptName" style="width: 120px"  clearable placeholder="请输入名称" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="发单方" prop="releaseName">
        <el-input v-model="searchForm.releaseName" style="width: 120px"  clearable placeholder="请输入名称" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="订单类型" prop="type">
        <el-select v-model="searchForm.type"  style="width: 120px"  @keypress.enter.native="search" clearable placeholder="订单类型">
          <el-option label="用工单" :value="0"></el-option>
          <el-option label="货运单" :value="1"></el-option>
          <el-option label="订餐单" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="订单状态" prop="status">
        <el-select v-model="searchForm.status" style="width: 100px"  @keypress.enter.native="search" clearable placeholder="状态">
        <el-option label="待支付" :value="0"></el-option>
        <el-option label="待接单" :value="1"></el-option>
        <el-option label="已接单" :value="2"></el-option>
        <el-option label="进行中" :value="3"></el-option>
        <el-option label="已完成" :value="4"></el-option>
        <el-option label="已取消" :value="99"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="发布时间"   prop="createTimeStart"  label-width="100px" >
        <el-date-picker type="datetime"  style="width: 150px"  v-model="searchForm.createTimeStart" clearable value-format="yyyy-MM-dd HH:mm:ss"
                        placeholder="开始时间" /> -
      </el-form-item>
      <el-form-item label="" prop="createTimeEnd"   label-width="0px" >
        <el-date-picker type="datetime"  style="width: 150px"  v-model="searchForm.createTimeEnd" clearable value-format="yyyy-MM-dd HH:mm:ss"
                        placeholder="结束时间" />
      </el-form-item>
      <el-form-item label="接单时间" prop="acceptTimeStart"  label-width="100px" >
        <el-date-picker type="datetime"  style="width: 150px"  v-model="searchForm.acceptTimeStart" clearable value-format="yyyy-MM-dd HH:mm:ss"
                        placeholder="开始时间" /> -
      </el-form-item>
      <el-form-item label="" prop="acceptTimeEnd"  label-width="0px" >
        <el-date-picker type="datetime"  style="width: 150px"  v-model="searchForm.acceptTimeEnd" clearable value-format="yyyy-MM-dd HH:mm:ss"
                        placeholder="结束时间" />
      </el-form-item>
      <el-form-item label="完成时间"    prop="doneTimeStart"   label-width="100px" >
        <el-date-picker type="datetime"  style="width: 150px"  v-model="searchForm.doneTimeStart" clearable value-format="yyyy-MM-dd HH:mm:ss"
                        placeholder="开始时间" /> -
      </el-form-item>
      <el-form-item label="" prop="doneTimeEnd"  label-width="0px" >
        <el-date-picker type="datetime"  style="width: 150px"  v-model="searchForm.doneTimeEnd" clearable value-format="yyyy-MM-dd HH:mm:ss"
                        placeholder="结束时间" />
      </el-form-item>
      <section>
        <el-button type="primary" @click="search">搜索</el-button>
        <el-button @click="reset">重置</el-button>
        <el-button type="primary" :loading="isWorking.export" @click="exportExcel">导出</el-button>
      </section>
    </el-form>
    <!-- 表格和分页 -->
    <template v-slot:table-wrap>
<!--      <ul class="toolbar" v-permissions="['business:orders:create', 'business:orders:delete']">
        <li><el-button type="primary" @click="$refs.operaOrdersWindow.open('新建订单信息记录')" icon="el-icon-plus" v-permissions="['business:orders:create']">新建</el-button></li>
        <li><el-button @click="deleteByIdInBatch" icon="el-icon-delete" v-permissions="['business:orders:delete']">删除</el-button></li>
      </ul>-->
      <el-table
         :height="tableHeightNew"
        v-loading="isWorking.search"
        :data="tableData.list"
        stripe
        @selection-change="handleSelectionChange"
      >
        <el-table-column prop="code" label="订单编号" width="180px" fixed="left">
          <template slot-scope="{row}">
            <span style="cursor: pointer;color: #2E68EC" @click="openDetail(row)">{{row.code}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="statusName" label="订单状态" min-width="100px"  >
          <template slot-scope="{row}">
          <span :class="'orderstate'+row.status">{{row.statusName}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="type" label="订单类型" min-width="100px">
          <template slot-scope="{row}">
            <span v-if="row.type==0">用工单</span>
            <span v-if="row.type==1">货运单</span>
            <span v-if="row.type==2">订餐单</span>
          </template>
        </el-table-column>
        <el-table-column prop="orderContent" label="订单内容"  width="200px" :show-overflow-tooltip='true'></el-table-column>
        <el-table-column prop="releaseName" label="发单方"  min-width="100px" :show-overflow-tooltip='true'>
          <template slot-scope="{row}">
           <span v-if="row.releaseName || row.releasePhone">{{(row.releaseName||'') +' - ' +(row.releasePhone||'')  }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="acceptName" label="接单方" min-width="100px" :show-overflow-tooltip='true'>
          <template slot-scope="{row}">
            <span v-if="row.acceptName || row.acceptPhone">{{(row.acceptName||'') +' - ' +(row.acceptPhone ||'')  }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="发布时间" min-width="150px"></el-table-column>
        <el-table-column prop="acceptTime" label="接单时间" min-width="150px"></el-table-column>
        <el-table-column prop="finishTime" label="完成时间" min-width="150px"></el-table-column>
        <el-table-column prop="estimatedAccount" label="预估金额（元）" min-width="150px">
          <template slot-scope="{row}">
            <span class="yellowstate">{{((row.estimatedAccount || 0)/100).toFixed(2)}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="payAccount" label="实付金额（元）" min-width="150px">
          <template slot-scope="{row}">
            <span class="yellowstate">{{((row.payAccount || 0)/100).toFixed(2)}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="acceptType" label="接单类型" min-width="100px">
          <template slot-scope="{row}">
            <span v-if="row.acceptType==0">手动接单</span>
            <span v-if="row.acceptType==1">系统派单</span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          align="center"
          min-width="150"
          fixed="right"
        >
          <template slot-scope="{row}">
            <el-button type="text" class="redstate" @click="cancelDo(row)" v-if="row.status>-1 && row.status<4" icon="el-icon-delete" v-permissions="['business:orders:update']">取消</el-button>
            <el-button type="text" @click="openDetail( row)" icon="el-icon-info"  >详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
        :pagination="tableData.pagination"
      >
      </pagination>
    </template>
    <!-- 新建/修改 -->
    <OperaOrderDetailWindow ref="OperaOrderDetailWindow" @success="handlePageChange"/>
  </TableLayout>
</template>

<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import Pagination from '@/components/common/Pagination'
import OperaOrderDetailWindow from '@/components/business/OperaOrderDetailWindow'
import { cancel } from '@/api/business/orders'
export default {
  name: 'Orders',
  extends: BaseTable,
  components: { TableLayout, Pagination, OperaOrderDetailWindow },
  data () {
    return {
      // 搜索
      searchForm: {
        acceptName: null,
        releaseName: null,
        type: null,
        createTimeEnd: null,
        createTimeStart: null,
        acceptTimeStart: null,
        acceptTimeEnd: null,
        doneTimeStart: null,
        doneTimeEnd: null,
        status: null,
        code: null
      }
    }
  },
  created () {
    this.config({
      module: '订单信息记录',
      api: '/business/orders',
      'field.id': 'id',
      'field.main': 'id'
    })
    this.search()
  },
  reset () {
    this.searchForm = {
      acceptName: null,
      releaseName: null,
      type: null,
      createTimeEnd: null,
      createTimeStart: null,
      acceptTimeStart: null,
      acceptTimeEnd: null,
      doneTimeStart: null,
      doneTimeEnd: null,
      status: null,
      code: null
    }
    this.search()
  },
  methods: {
    openDetail (row) {
      this.$refs.OperaOrderDetailWindow.open('订单详情', row )
    },
    cancelDo (row) {
      this.$dialog.actionConfirm('您确认【取消】该订单吗？', '操作确认')
        .then(() => {
          this.dealing = true
          cancel(row.id)
            .then(res => {
              this.$tip.apiSuccess('操作成功')
              this.search()
            })
            .catch(e => {
              this.$tip.apiFailed(e)
            })
            .finally(() => {
              this.dealing = false
            })
        })
    }
  }
}
</script>
